import { AuthPopupModel } from 'src/components/authPopup/model';

class ConnectedAccountsClinicFormModel extends AuthPopupModel {
  id = 'ConnectedAccountsClinicFormModel';
  persistent = false;

  _events = {
    profile: 'handleProfile'
  };

  constructor() {
    super();

    this.apiConfig.createAccount = {
      url: '/auth/createConnectedAccount',
      validation: {
        name: 'name',
        username: 'username',
        specialist: 'specialist',
        description: 'description'
      }
    };
  }

  resetState = () => {
    this.setState({
      avatar: '',
      name: '',
      username: '',
      specialist: [],
      description: '',
      usernameSuggestion: ''
    });
  };

  createAccount = () => {
    this.api(
      'createAccount',
      {
        role: 'clinic',
        files: [this.state.avatar].filter((i) => !!i),
        name: this.state.name,
        username: this.state.username,
        specialist: this.state.specialist,
        description: this.state.description,
        isDoctor: false
      },
      (err, res, success) => {
        if (success) {
          this.emit('resetStates');
          this.emit('auth', res);
          this.foxsocket().disconnect();
          this.foxsocket().ensureConnect(true);
          this.emit('accountSwitched', res);
        }
      }
    );
  };
  handleProfile = (profile) => {
    this.setStateSilent({ user: profile });
  };
}

const model = new ConnectedAccountsClinicFormModel();
export default model;
